"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("courses").controller("CourseCtrl", CourseCtrl);

  function CourseCtrl($rootScope, $scope, $timeout, $controller, FormlyService, CustomListsService, CustomersService, CoursesService, params) {
    var _this = this;

    var vm = this;

    vm.log = debug("pages:users:controller");

    vm.ctrlName = "CourseCtrl";

    vm.oneAtATime = true;

    vm.createFields = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return localforage.getItem("oneAtATime");

            case 2:
              vm.oneAtATime = _context.sent;
              _context.t0 = FormlyService.text("name", "Numéro de formation", true, {
                className: "col-xs-12 col-sm-12 col-md-12"
              });
              _context.t1 = FormlyService.date("startDate", "Date", true, {
                className: "col-xs-12 col-sm-12 col-md-12"
              });
              _context.t2 = FormlyService;
              _context.next = 8;
              return CustomListsService.getSelectArray("courseDuration");

            case 8:
              _context.t3 = _context.sent;
              _context.t4 = {
                className: "col-xs-12 col-sm-12 col-md-12"
              };
              _context.t5 = _context.t2.list.call(_context.t2, "duration", "Durée", _context.t3, false, _context.t4);
              _context.t6 = FormlyService;
              _context.next = 14;
              return CustomListsService.getSelectArray("courseType");

            case 14:
              _context.t7 = _context.sent;
              _context.t8 = {
                className: "col-xs-12 col-sm-12 col-md-12"
              };
              _context.t9 = _context.t6.list.call(_context.t6, "type", "Type de formation", _context.t7, true, _context.t8);
              _context.t10 = {
                key: "elearningIds",
                type: "select-elearnings",
                className: "col-xs-12 col-sm-12 col-md-12",
                hideExpression: "model.type !== 'C8' && model.type !== 'C10' && model.type !== 'C11'",
                templateOptions: {
                  label: ""
                }
              };
              _context.t11 = FormlyService.bool("forumMode", "Mode Forum Ouvert", false, {
                className: "col-xs-12 col-sm-12 col-md-12"
              });
              _context.t12 = FormlyService.number("amount", "Coût HT", false, {
                className: "col-xs-12 col-sm-12 col-md-12"
              });
              _context.t13 = FormlyService.textArea("note", "Commentaires", "...", false, {
                className: "col-xs-12 col-sm-12 col-md-12"
              });
              _context.t14 = [_context.t0, _context.t1, _context.t5, _context.t9, _context.t10, _context.t11, _context.t12, _context.t13];
              _context.t15 = {
                mainTitle: "Informations",
                fields: _context.t14
              };
              _context.t16 = [_context.t15];
              _context.t17 = {
                class: "col-xs-12 col-sm-3 col-md-3",
                boxes: _context.t16
              };
              _context.t18 = {
                class: "col-xs-12 col-sm-5 col-md-5",
                boxes: [{
                  mainTitle: "Stagiaires",
                  fields: [{
                    key: "traineesId",
                    type: "select-users",
                    className: "col-xs-12 col-sm-12 col-md-12",
                    templateOptions: {
                      label: ""
                    }
                  }]
                }, {
                  mainTitle: "Documents liés à la formation",
                  fields: [FormlyService.doc("docs", "", "course", false, {
                    className: "col-xs-12 col-sm-12 col-md-12"
                  }, "", false)]
                }]
              };
              _context.t19 = {
                class: "col-xs-12 col-sm-4 col-md-4",
                boxes: [{
                  mainTitle: "Formateurs de la société",
                  fields: [{
                    key: "customerTrainersId",
                    type: "select-users",
                    className: "col-xs-12 col-sm-12 col-md-12",
                    templateOptions: {
                      position: "Formateur",
                      label: ""
                    }
                  }]
                }, {
                  mainTitle: "Formateurs LVR Fleet",
                  fields: [{
                    key: "trainersId",
                    type: "select-users",
                    className: "col-xs-12 col-sm-12 col-md-12",
                    templateOptions: {
                      position: "Formateur LVR",
                      label: ""
                    }
                  }]
                }]
              };
              _context.t20 = [_context.t17, _context.t18, _context.t19];
              _context.t21 = {
                columns: _context.t20
              };
              vm.rows = [_context.t21];


              $timeout(function () {}, 0);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.log("load datas ...");

    vm.ready = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var customerName;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!($rootScope.$super == true)) {
                _context2.next = 5;
                break;
              }

              _context2.next = 3;
              return CustomersService.getNameById(vm.model.customerId);

            case 3:
              customerName = _context2.sent;

              vm.displayTitle += " pour " + customerName;

            case 5:

              $timeout(function () {
                vm.createFields();
              }, 0);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    $controller("CreateBaseController", {
      vm: vm,
      $scope: $scope,
      service: CoursesService,
      listPage: "courses",
      nameModel: "une formation",
      params: params
    });

    vm.check = function () {
      var save = true;

      if (!vm.model.name) {
        Notiflix.Notify.failure("Vous n'avez pas indiqué le numéro de la formation");
        save = false;
      }

      if (!vm.model.startDate) {
        Notiflix.Notify.failure("Vous n'avez pas indiqué la date de la formation");
        save = false;
      }

      if (save) {
        vm.save();
      }
    };
  }
})();